import React from 'react'

import { AlarmRiskBollNotification, EmailNotificationContainer, RiskNameNotification } from './styles'

export const EmailNotification: React.FC = () => {
    return (
        <EmailNotificationContainer>
            <div className={'title-notification-email'}>
                <AlarmRiskBollNotification color={'#AE1F1F'} />
                <label className={'label-title-email'}>Alert name that could be a entity name</label>
            </div>
            <label className={'label-name-group'}>Notified to <span> Group name</span></label>
            <label className={'label-time-notification'}>
                <i className="fal fa-history"></i>
                Triggered 5 times in the last 7 hours
                <i className="fal fa-clock"></i>
                Last triggered 2 hours ago
            </label>
            <div className={'description-notification'}>
                <RiskNameNotification color={'#AE1F1F'}>{'fatal'}</RiskNameNotification>
                <label>
                    Alert event: Alert event description, this area right here is limited to 150 characters. Quo sut labore
                    id dolor ipsum et culpa harum eum pariatur voluptas sit.
                </label>
                <ul className={'list-bowties-context'}>
                   <label> Bowtie's context: </label>
                    <li > BW 001 | Hazard texto | Top Event texto | Operation</li>
                    <li> BW 123 | Hazard texto | Top Event texto | Operation</li>
                </ul>
                <label> Rule creation date: 2019/04/06 </label>
            </div>
            <label>Alert Timeline</label>
        </EmailNotificationContainer>
    )
}
